import { useSetRecoilState, useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { useFetchWrapper } from "./useFetchWrapper";
import { authAtom, usersAtom, isLoginAtom, isModalAtom } from "../atoms";

export { useUserActions };

function useUserActions() {
  const baseUrl = "api/auth";
  const fetchWrapper = useFetchWrapper();
  const setAuth = useSetRecoilState(authAtom);
  const setUsers = useSetRecoilState(usersAtom);
  const setlogin = useSetRecoilState(isLoginAtom);
  const navigate = useNavigate();

  //모달 닫기 제어
  const [, setisMocalopen] = useRecoilState(isModalAtom);
  const handleClose = () => setisMocalopen(false);

  const goLogin = (param) => {
    navigate(param);
  };

  return {
    login,
    logout,
    getAll,
  };

  function login(email, password, head) {
    return fetchWrapper
      .post(`${baseUrl}/login`, { email, password })
      .then((user) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("id", email);
        setAuth(user);
        setUsers(email);
        setlogin(true);
        handleClose();
        // to home page
        goLogin(head);
      });
  }

  function logout() {
    // remove user from local storage, set auth state to null and redirect to login page
    localStorage.removeItem("user");
    localStorage.removeItem("id");
    setAuth(null);
    setUsers(null);
    setlogin(false);
    goLogin("/");
  }

  function getAll() {
    return fetchWrapper.get(baseUrl).then(setUsers);
  }
}
